var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 439,
    viewBox: "0 0 439 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7006_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.522 219.692L430.33 48.8791C441.446 37.7684 441.446 19.804 430.33 8.69328C419.219 -2.41741 401.255 -2.41741 390.144 8.69328L219.331 179.507L48.5228 8.69328C37.4069 -2.41741 19.4476 -2.41741 8.33693 8.69328C-2.77898 19.804 -2.77898 37.7684 8.33693 48.8791L179.145 219.692L8.33693 390.506C-2.77898 401.616 -2.77898 419.581 8.33693 430.692C13.8741 436.234 21.1546 439.018 28.4299 439.018C35.7051 439.018 42.9804 436.234 48.5228 430.692L219.331 259.878L390.144 430.692C395.686 436.234 402.962 439.018 410.237 439.018C417.512 439.018 424.788 436.234 430.33 430.692C441.446 419.581 441.446 401.616 430.33 390.506L259.522 219.692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7006_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438.667,
    height: 438.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.189e0c53da3e6bc143bb0ee7c3ad0615.svg";
export { ForwardRef as ReactComponent };